import { makeVar, useReactiveVar } from '@apollo/client';

interface IUseStudentAdvicedIdCache {
  studentId: string | undefined;
  setStudentId: (value: string | undefined) => void;
}

export const studentAdvicedId = makeVar<string | undefined>(undefined);

export const useStudentAdvicedIdCache = (): IUseStudentAdvicedIdCache => {
  const studentId = useReactiveVar(studentAdvicedId);

  const setStudentId = (value: string | undefined): void => {
    studentAdvicedId(value);
  };

  return {
    studentId,
    setStudentId,
  };
};
